import {
    getSessionToken
} from "../helpers/getSessionToken";
import {
    detailsGrid,
    detailsSection,
    initDetailsTrigger,
} from "./detailsModal";

const MESSAGE_DETAILS_MODAL_ID = 'growtypeChatMessageDetailsModal';

const messageDetailsConfig = {
    modalId: MESSAGE_DETAILS_MODAL_ID,
    title: 'Message details',
    bodyClass: 'growtype-chat-message-details-body',
    copyClass: 'growtype-chat-message-details-copy',
    copyLabel: 'message details',
    isEnabled: () => !!window.growtype_chat_ajax?.show_message_details,
    getAction: () => window.growtype_chat_ajax?.message_details_action,
    getSessionToken: ($trigger) => getSessionToken($trigger.closest('.g-chatform')),
    buildRequest($trigger) {
        const encryptedMessageId = $trigger.closest('.g-chatform-message').attr('data-id') || '';

        if (!encryptedMessageId) {
            return null;
        }

        return { message_id: encryptedMessageId };
    },
    renderError: () => 'Unable to load message details.',
    onAbort: () => console.error('[message-details] missing message id or session token'),
    render(data) {
        const sessionSettings = data.session_settings || {};
        const generation = data.generation || {};

        const sections = [
            detailsGrid('Message', [
                ['Message ID', data.message_id],
                ['Session ID', data.session_id],
                ['Session token', data.session_token],
                ['Message user ID', data.message_user_id],
                ['Type', data.message_type],
                ['Updated at', data.message_updated_at],
                ['Main text', data.content?.main_text],
            ]),
            detailsSection('Users', data.session_user_ids),
            detailsSection('Session settings', sessionSettings),
            detailsGrid('Generation', [
                ['Captured at', generation.captured_at],
                ['Assistant user ID', generation.assistant_user_id],
                ['Requested model', generation.requested_model],
                ['Actual model', generation.actual_model_used],
                ['Fallback used', generation.fallback_used],
                ['Request category', generation.request_category],
                ['Request value', generation.request_value],
                ['LLM message count', generation.llm_message_count],
            ]),
            detailsSection('Question evaluation', generation.question_evaluation),
            detailsSection('System prompt', generation.system_prompt),
            detailsSection('LLM messages tail', generation.llm_messages_tail),
            detailsSection('LLM params', generation.llm_params),
        ];

        return `
            <div class="growtype-chat-message-details" style="display:flex;flex-direction:column;gap:18px;">
                ${sections.join('')}
            </div>
        `;
    },
};

export function initMessageDetails() {
    initDetailsTrigger({
        selector: '.g-chatform-message-details',
        event: 'click.growtypeChatMessageDetails',
        config: messageDetailsConfig,
    });
}
